export default __webpack_public_path__ + "static/revolver-b4524aef0b7730c75afd3d0e93cbf3ec.jpg";